import { AlertCircle, CheckCircle, Clock, XCircle } from "lucide-react";
import type { ReactNode } from "react";
import type { BadgeVariant } from "../../common/Badge";
import Badge from "../../common/Badge";
import { getExitTableStatusVariant } from "../../../utils/badgeVariants";

export function separationStatusIcon(variant: BadgeVariant): ReactNode {
  switch (variant) {
    case "green":
      return <CheckCircle className="w-4 h-4 text-green-500" aria-hidden />;
    case "red":
      return <XCircle className="w-4 h-4 text-red-500" aria-hidden />;
    case "yellow":
    case "orange":
      return <Clock className="w-4 h-4 text-yellow-500" aria-hidden />;
    default:
      return <AlertCircle className="w-4 h-4 text-slate-500" aria-hidden />;
  }
}

type SeparationStatusBadgeProps = {
  label: string;
  /** Exit lifecycle / checklist raw phase (e.g. SUBMITTED, COMPLETED). */
  phase?: string | null;
  /** When set, overrides phase-based variant (e.g. termination rows). */
  variant?: BadgeVariant;
};

/**
 * Same pattern as leave apply table: {@link Badge} + workflow-style variant + icon.
 */
export function SeparationStatusBadge({
  label,
  phase,
  variant: variantProp,
}: SeparationStatusBadgeProps) {
  const phaseVariant = getExitTableStatusVariant(phase ?? undefined);
  const approvedByLabel = /\bapproved\b/i.test(label);
  const variant =
    variantProp ??
    (approvedByLabel && (phaseVariant === "yellow" || phaseVariant === "gray")
      ? "green"
      : phaseVariant);
  return (
    <Badge variant={variant} size="middle" icon={separationStatusIcon(variant)}>
      {label}
    </Badge>
  );
}
